<template>
  <main>
    <section class="fk-contents">

      <div class="mod-form-block">
        <span class="label">{{text.ConfirmTable}}</span>
        <p class="confirm-seat-num">{{model.tableNumber}}</p>
      </div>

      <p class="mod-form-btn"><a href="#" class="btn-base btn-sub" @click.prevent="execConfirm()">{{text.FixedTable}}</a></p>
      <p class="mod-form-btn"><a href="#" class="btn-base btn-negative btn-quit" @click.prevent="backInput()">{{text.CorrectionTable}}</a></p>
    </section>
  </main>
</template>

<script>
import CommonMixin from '@/mixins/CommonMixin'
import DisplayErrorMixin from '@/mixins/DisplayErrorMixin'
export default {
  name: 'FKMOTableOrderConfirm',
  data () {
    return {
      text: {
        ConfirmTable: null,
        TableNumber: null,
        FixedTable: null,
        CorrectionTable: null
      },
      model: {
        tableNumber: null
      }
    }
  },
  mixins: [ CommonMixin, DisplayErrorMixin ],
  computed: {
    getOrderDetail () {
      return this.$store.getters.orderDetail
    },
    getDisabledButton () {
      return this.$store.getters.disabledButton
    }
  },
  methods: {
    execConfirm: function () {
      if (this.getDisabledButton) {
        return false
      }
      this.setDisabledButton(true)

      const _that = this

      this.callApi('SetTableNumber',
        {
          'order_id': this.getOrderDetail.orderId,
          'table_number': this.getOrderDetail.tableNumber
        }
      )
      // this.axios.get('/static/stub/set_tablenumber.json')
        .then(function (res) {
          if (res.data.result) {
            _that.$router.push({ name: 'PaymentMethod' })
          } else {
            _that.errorFromApi(res.data.errorCode, res.data.error)
          }
        })
        .catch((error) => {
          _that.errorFromAxios(error)
        })
        .finally(() => {
          _that.setDisabledButton(false)
        })
    },
    backInput: function () {
      this.$router.push({ name: 'TableOrderInput' })
    },
    initView: function () {
      // マウント後に画面出力する文字列を設定する
      this.text.ConfirmTable = this.$i18n.t('ReceiveMethod.ConfirmTable')
      this.text.TableNumber = this.$i18n.t('ReceiveMethod.TableNumber')
      this.text.FixedTable = this.$i18n.t('ReceiveMethod.FixedTable')
      this.text.CorrectionTable = this.$i18n.t('ReceiveMethod.CorrectionTable')
    },
    init: function () {
      // 初期化
      // テーブル番号をセットする
      this.model.tableNumber = this.getOrderDetail.tableNumber
    }
  },
  beforeMount () {
    this.init()
  },
  mounted () {
    this.initView()
  },
  beforeUpdate () {
    this.restoreScaleRate('default') // 拡大縮小のロックを開放
  },
  destroyed () {
    this.restoreScaleRate('reset') // scaleをリセット
  }
}
</script>



// WEBPACK FOOTER //
// src/components/TableOrderConfirm.vue